import styled from 'styled-components';

export const Account = styled.abbr`
    &&& {
        display: inline-flex;
        overflow: hidden;
        text-decoration: none;
        user-select: none;
    }
`;

export const Ellipsis = styled.span`
    &&& {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-indent: 0.5625rem;
        margin-left: -0.5625rem;
    }
`;
